import React from 'react';
import { Box, Chip, Typography } from '@mui/material';
import { searchSectionTitle } from '../../utils/rankProductsByTags';

const SearchResultSectionHeading = ({ matchedTags = [], children }) => {
  const showHeading = matchedTags.length > 0;

  if (!showHeading && !children) return null;

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: showHeading ? 'space-between' : 'flex-end',
        gap: 1,
        alignSelf: 'stretch',
      }}
    >
      {showHeading && (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            flexWrap: 'wrap',
            gap: 1,
            flex: 1,
            minWidth: 0,
          }}
        >
          <Typography
            sx={{
              fontFamily: 'Nunito',
              fontSize: '16px',
              fontWeight: 700,
              lineHeight: '24px',
              color: 'text.primary',
            }}
          >
            {searchSectionTitle()}
          </Typography>
          {matchedTags.map((tag) => (
            <Chip
              key={tag.id}
              label={tag.name}
              size="small"
              color="primary"
            />
          ))}
        </Box>
      )}
      {children}
    </Box>
  );
};

export default SearchResultSectionHeading;
